import { render, staticRenderFns } from "./WaybillSigne.vue?vue&type=template&id=368a811b&scoped=true&"
import script from "./WaybillSigne.vue?vue&type=script&lang=js&"
export * from "./WaybillSigne.vue?vue&type=script&lang=js&"
import style0 from "./WaybillSigne.vue?vue&type=style&index=0&id=368a811b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368a811b",
  null
  
)

export default component.exports